module.exports = __webpack_public_path__ + "static/1-585fc0e0fdbe18afb15b058c81d092ba.jpg";